<script setup lang="ts">
/*
 * Flat amber count badge for the header cart and wishlist buttons. Rings once
 * (PULSE_MS) whenever the count changes, so adding an item is felt even when
 * the fly-to-cart animation is off. Reduced motion is handled in app.css.
 * Always mounted by the parent so the 0 -> 1 change is also seen.
 */
import { onBeforeUnmount, ref, watch } from 'vue';

/** Matches the 1.8 s cycle of `animate-pulse-ring`. */
const PULSE_MS = 1800;

const props = defineProps<{ count: number }>();

const pulsing = ref(false);
let timer: number | undefined;

watch(() => props.count, () => {
  window.clearTimeout(timer);
  pulsing.value = true;
  timer = window.setTimeout(() => { pulsing.value = false; }, PULSE_MS);
});
onBeforeUnmount(() => window.clearTimeout(timer));
</script>

<template>
  <span
    v-if="count > 0"
    :key="count"
    class="absolute right-0 top-0 inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-accent px-1 font-heading text-[10px] font-bold leading-none text-text-inv"
    :class="{ 'animate-pulse-ring': pulsing }"
  >{{ count }}</span>
</template>
